<template>
    <div>
        <v-row class="mt-1">
            <v-col cols="12" sm="4" md="4">
                <v-row v-if="!insuranceBasedListings.includes(editData.listing_type)">
                    <v-col cols="12">
                        <v-text-field 
                            v-model="editData.company_broker_dealer"
                            label="Broker Dealers">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row v-if="!insuranceBasedListings.includes(editData.listing_type)">
                    <v-col cols="12">
                        <v-text-field 
                            v-model="editData.company_custodians"
                            label="Custodians"
                            hint="Separate mutliple lines with a semi-colon"
                            persistent-hint>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row v-if="!insuranceBasedListings.includes(editData.listing_type)">
                    <v-col cols="12">
                        <v-text-field 
                            v-model="editData.company_tamps"
                            label="TAMPS"
                            hint="Separate mutliple lines with a semi-colon"
                            persistent-hint>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row v-if="insuranceBasedListings.includes(editData.listing_type)">
                    <v-col cols="12">
                        <v-textarea 
                            v-model="editData.company_insurance_carriers"
                            rows="9"
                            auto-grow
                            label="Insurance Carriers & Percentage of Revenue"
                            hint="Separate mutliple lines with a semi-colon"
                            persistent-hint>
                        </v-textarea>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" sm="4" md="4">
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model="editData.company_households"
                            label="Number of Households">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model="editData.company_households_1m_aum"
                            label="Households with 1M+ AUM">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model="editData.company_local_clients"
                            label="Percentage of Local Clients"
                            append-icon="mdi-percent">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" sm="4" md="4">
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model="editData.company_average_client_age"
                            label="Average Client Age">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model="editData.company_average_client_tenture"
                            label="Average Client Tenture (in years)">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model="editData.company_key_method_acquisition"
                            label="Key Method of Acquisition">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-switch 
                            :input-value="dataMultiGenPlan"
                            color="accent" 
                            :label="`Multi Generational Plan: ${dataMultiGenPlan == true ? ' Yes':' No'}`"
                            @change="toggleMultiGenPlanFlag($event)">
                        </v-switch>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>


<script>
    export default {
        name: 'CompanyInfo',
        props: [
            'editData',
            'insuranceBasedListings'
        ],

        computed: {
            dataMultiGenPlan: {
                get: function() {
                    return this.editData.company_multi_gen_plan
                },
                set: function(val) {
                    return val
                }
            }
        },

        methods: {
            toggleMultiGenPlanFlag: function (toggle_multigenplan) {
                this.editData.company_multi_gen_plan = toggle_multigenplan
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/prospectus-sections/CompanyInfo.vue